export default {"src":"/_next/static/media/lock.444658b5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};